import client from "../config/axiosConfig";

export const getConsultationApi = (consultationId) =>
  client.get(`/consultation/${consultationId}`);
export const getOpenConsultationsApi = () =>
  client.get(`/consultation/provider/open`);
export const assignConsultationApi = (consultationId) =>
  client.put(`/consultation/${consultationId}/assign`);
